import BoxLayout from "./BoxLayout";
import { motion } from "framer-motion";
import { coreFeatures, technicalExpertise } from "./data";

export const TechnicalExpertise = () => {
  return (
    <div className="space-y-10 ">
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
        className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px]  text-center   font-bold text-dark font-butler  md:w-10/12 lg:w-8/12 xl:w-7/12 mx-auto "
      > 
        Our Technical Expertise for Mobile App Development
      </motion.h2>
        <div className="flex flex-wrap  gap-x-6 gap-y-8 justify-center ">
        {technicalExpertise.map((list, index) => (
          <BoxLayout
            key={index}
            heading={list.heading}
            text={list.text}
            iconImg={list.img}
            color="bg-primary/40"
          />
        ))}
      </div>
    


       
    </div>
  );
};
